<template>
	<div class="video-footer">
		<div class="container-fluid">
			<div class="footer-area">
				深圳学必优教育科技有限公司&nbsp;&nbsp;版权所有&nbsp;&nbsp;粤ICP备11036314号
				<p>官网：https://itmsw.com</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'VideoFooter',
		mounted() {}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/common/VideoFooter.scss';
</style>